import { type PlatformLayout, platformHeight } from "./types";

/** Shipping floor bounds; the legacy name is also used by route telemetry. */
export const CONSERVATORY_GROUND = {
  name: "collision_ground_fallback", x: 70, y: -0.25, w: 200, h: 0.5, d: 4,
} as const;

/** Unchanged escort staircase/landings and Sundew service surface. */
export const OVERGROWN_CONSERVATORY_PLATFORMS: PlatformLayout = {
  level: "OvergrownConservatory",
  groundTopY: 0,
  platforms: [
    { name: "escortSupportUpperA", w: 8, h: 0.4, d: 2, x: 115, y: 8 },
    { name: "escortSupportUpperB", w: 7, h: 0.4, d: 2, x: 125, y: 9 },
    { name: "escortLadderA_1", w: 2.2, h: 0.4, d: 2, x: 103, y: 1.6 },
    { name: "escortLadderA_2", w: 2.2, h: 0.4, d: 2, x: 105.4, y: 3.2 },
    { name: "escortLadderA_3", w: 2.2, h: 0.4, d: 2, x: 107.8, y: 4.8 },
    { name: "escortLadderA_4", w: 2.2, h: 0.4, d: 2, x: 110.2, y: 6.4 },
    { name: "sundewMawTonguePlatform", w: 3.6, h: 0.35, d: 2, x: 133, y: 2.1 },
  ],
};

export type ConservatoryActorSupport = "ground" | "escortSupportUpperA" | "escortSupportUpperB";

/** Actor art shares the physical deck data, without moving its logical root. */
export function conservatoryActorSupportY(support: ConservatoryActorSupport = "ground"): number {
  if (support === "ground") return CONSERVATORY_GROUND.y + CONSERVATORY_GROUND.h / 2;
  const deck = OVERGROWN_CONSERVATORY_PLATFORMS.platforms.find(p => p.name === support)!;
  return deck.y + platformHeight(deck) / 2;
}
